// LocalStorage helpers for the admin JWT + cached admin profile.
const TOKEN_KEY = 'upsc_admin_token';
const ADMIN_KEY = 'upsc_admin_profile';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const getStoredAdmin = () => {
  try {
    const raw = localStorage.getItem(ADMIN_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};
export const setStoredAdmin = (admin) =>
  localStorage.setItem(ADMIN_KEY, JSON.stringify(admin));
export const clearStoredAdmin = () => localStorage.removeItem(ADMIN_KEY);

export const clearSession = () => {
  clearToken();
  clearStoredAdmin();
};
